const ENV_CONFIG_PREFIX = 'VUE_APP_CONFIG_';

/**
 * This provider loads envs starting with `ENV_CONFIG_PREFIX` as remote config variables,
 * to use a config, call with config_name, it will be mapped to `${ENV_CONFIG_PREFIX} + ${config_name}`. ex:
 *
 * VUE_APP_CONFIG_MAGIC_NUMBER maps to `magic_number` config accessed throught $remoteConfig.string('magic_number').
 */
class EnvRemoteConfigProvider {

  constructor () {
    this.config = new Map();

    try {
      const entries = Object.entries(process.env,).
        filter((entry,) => entry[0].startsWith(ENV_CONFIG_PREFIX,),).
        map((entry,) => [entry[0].replace(ENV_CONFIG_PREFIX, '',).toLowerCase(), entry[1],],);

      this.config = new Map(entries,);
    } catch (err) {
      console.error('err', err,);
    }
  }

  /**
   * @returns {boolean} the config for `key` or `false` if not found
   *
   * @param {String} key the name of config to fetch
   */
  boolean (key,) {
    return Boolean(this.config.get(key,),) || false;
  }

  /**
   * @returns {Object?} the config for `key` or `null` if not found
   *
   * @param {String} key the name of config to fetch
   */
  object (key,) {
    try {
      if (this.config.has(key,)) {
        return JSON.parse(this.config.get(key,),);
      }
    } catch (err) {
      console.error(err,);
    }

    return null;
  }

  /**
   * @returns {string} the config for `key` or `""` if not found
   *
   * @param {String} key the name of config to fetch
   */
  string (key,) {
    return String(this.config.get(key,),) || '';
  }

  all () {
    return Object.fromEntries(this.config,);
  }
}

export default {
  install: (Vue,) => {
    Vue.prototype.$remoteConfig = new EnvRemoteConfigProvider();
  },
};
